import { createActionGroup, props } from '@ngrx/store'
import { BreakpointState } from '@angular/cdk/layout'

export const LayoutActions = createActionGroup({
	source: 'Layout',
	events: {
		'Change Layout': props<{ breakpointState: BreakpointState }>(),
	},
})
